export const PAYMENT = 'payment';



// WEBPACK FOOTER //
// ./app/constants/VIEWS.ts